import { useState, useEffect } from 'react';
import { useSupabaseClient, useUser } from '@supabase/auth-helpers-react';

export const useRoleRequests = () => {
  const supabase = useSupabaseClient();
  const user = useUser();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [pendingRequests, setPendingRequests] = useState([]);

  useEffect(() => {
    if (user) {
      fetchPendingRequests();
    }
  }, [user]);

  const fetchPendingRequests = async () => {
    try {
      setLoading(true);
      setError(null);

      const { data, error } = await supabase
        .from('role_requests')
        .select('*')
        .eq('user_id', user.id)
        .eq('status', 'pending');

      if (error) throw error;

      setPendingRequests(data || []);
    } catch (err) {
      setError(err.message);
      console.error('Error fetching role requests:', err);
    } finally {
      setLoading(false);
    }
  };

  const createRoleRequest = async (requestedRole) => {
    try {
      setError(null);

      // Check if there's already a pending request for this role
      const existingRequest = pendingRequests.find(
        req => req.requested_role === requestedRole
      );

      if (existingRequest) {
        throw new Error(`You already have a pending request for ${requestedRole} role`);
      }

      const { error } = await supabase
        .from('role_requests')
        .insert([{
          user_id: user.id,
          requested_role: requestedRole,
        }]);

      if (error) throw error;

      // Refresh pending requests
      await fetchPendingRequests();
      return { error: null };
    } catch (err) {
      setError(err.message);
      console.error('Error creating role request:', err);
      return { error: err };
    }
  };

  return {
    pendingRequests,
    loading,
    error,
    createRoleRequest,
    refreshRequests: fetchPendingRequests
  };
};
